// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';

import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';

const defaultOptions = {} as const;
export type ImportHistoryFields_EmployeeImportHistory_Fragment = { __typename?: 'EmployeeImportHistory' } & Pick<
  Types.EmployeeImportHistory,
  'id' | 'status' | 'totalRequestCount' | 'completedRequestCount' | 'createdAt' | 'updatedAt'
> &
  ImportHistoryFieldCreatedBy_EmployeeImportHistory_Fragment;

export type ImportHistoryFields_ManagerialAccountingImportHistory_Fragment = {
  __typename?: 'ManagerialAccountingImportHistory';
} & Pick<
  Types.ManagerialAccountingImportHistory,
  'id' | 'status' | 'totalRequestCount' | 'completedRequestCount' | 'createdAt' | 'updatedAt'
> &
  ImportHistoryFieldCreatedBy_ManagerialAccountingImportHistory_Fragment;

export type ImportHistoryFieldsFragment =
  | ImportHistoryFields_EmployeeImportHistory_Fragment
  | ImportHistoryFields_ManagerialAccountingImportHistory_Fragment;

export type ImportHistoryFieldCreatedBy_EmployeeImportHistory_Fragment = { __typename?: 'EmployeeImportHistory' } & {
  createdBy: Types.Maybe<
    { __typename?: 'Employee' } & {
      generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
        Types.EmployeeGeneralInformation,
        'preferredFullName'
      >;
    }
  >;
};

export type ImportHistoryFieldCreatedBy_ManagerialAccountingImportHistory_Fragment = {
  __typename?: 'ManagerialAccountingImportHistory';
} & {
  createdBy: Types.Maybe<
    { __typename?: 'Employee' } & {
      generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
        Types.EmployeeGeneralInformation,
        'preferredFullName'
      >;
    }
  >;
};

export type ImportHistoryFieldCreatedByFragment =
  | ImportHistoryFieldCreatedBy_EmployeeImportHistory_Fragment
  | ImportHistoryFieldCreatedBy_ManagerialAccountingImportHistory_Fragment;

export type ImportHistoryListQueryVariables = Types.Exact<{
  onlyMyTask: Types.Scalars['Boolean']['input'];
}>;

export type ImportHistoryListQuery = { __typename?: 'Query' } & {
  importHistoryList: Array<
    | ({ __typename: 'EmployeeImportHistory' } & Pick<Types.EmployeeImportHistory, 'format'> & {
          errors: Array<
            { __typename: 'EmployeeImportHistoryError' } & Pick<
              Types.EmployeeImportHistoryError,
              'columnName' | 'rowNumber' | 'message'
            >
          >;
        } & ImportHistoryFields_EmployeeImportHistory_Fragment)
    | ({ __typename: 'ManagerialAccountingImportHistory' } & {
        errors: Array<
          { __typename: 'ManagerialAccountingImportHistoryError' } & Pick<
            Types.ManagerialAccountingImportHistoryError,
            'year' | 'quarter' | 'category' | 'rowNumber' | 'message'
          > & {
              employee: Types.Maybe<
                { __typename?: 'Employee' } & {
                  generalInformation: { __typename?: 'EmployeeGeneralInformation' } & Pick<
                    Types.EmployeeGeneralInformation,
                    'preferredFullName'
                  >;
                }
              >;
            }
        >;
      } & ImportHistoryFields_ManagerialAccountingImportHistory_Fragment)
  >;
};

export const ImportHistoryFieldCreatedByFragmentDoc = /*#__PURE__*/ gql`
    fragment ImportHistoryFieldCreatedBy on ImportHistory {
  createdBy {
    generalInformation {
      preferredFullName
    }
  }
}
    `;
export const ImportHistoryFieldsFragmentDoc = /*#__PURE__*/ gql`
    fragment ImportHistoryFields on ImportHistory {
  id
  status
  totalRequestCount
  completedRequestCount
  createdAt
  updatedAt
  ...ImportHistoryFieldCreatedBy
}
    ${ImportHistoryFieldCreatedByFragmentDoc}`;
export const ImportHistoryListDocument = /*#__PURE__*/ gql`
    query importHistoryList($onlyMyTask: Boolean!) {
  importHistoryList: listImportHistories(onlyMyTask: $onlyMyTask) {
    __typename
    ...ImportHistoryFields
    errors {
      __typename
      rowNumber
      message
      ... on EmployeeImportHistoryError {
        columnName
      }
      ... on ManagerialAccountingImportHistoryError {
        employee {
          generalInformation {
            preferredFullName
          }
        }
        year
        quarter
        category
      }
    }
    ... on EmployeeImportHistory {
      format
    }
  }
}
    ${ImportHistoryFieldsFragmentDoc}`;

/**
 * __useImportHistoryListQuery__
 *
 * To run a query within a React component, call `useImportHistoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useImportHistoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImportHistoryListQuery({
 *   variables: {
 *      onlyMyTask: // value for 'onlyMyTask'
 *   },
 * });
 */
export function useImportHistoryListQuery(
  baseOptions: Apollo.QueryHookOptions<ImportHistoryListQuery, ImportHistoryListQueryVariables> &
    ({ variables: ImportHistoryListQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ImportHistoryListQuery, ImportHistoryListQueryVariables>(ImportHistoryListDocument, options);
}
export function useImportHistoryListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ImportHistoryListQuery, ImportHistoryListQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ImportHistoryListQuery, ImportHistoryListQueryVariables>(
    ImportHistoryListDocument,
    options,
  );
}
// @ts-expect-error
export function useImportHistoryListSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<ImportHistoryListQuery, ImportHistoryListQueryVariables>,
): Apollo.UseSuspenseQueryResult<ImportHistoryListQuery, ImportHistoryListQueryVariables>;
export function useImportHistoryListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ImportHistoryListQuery, ImportHistoryListQueryVariables>,
): Apollo.UseSuspenseQueryResult<ImportHistoryListQuery | undefined, ImportHistoryListQueryVariables>;
export function useImportHistoryListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ImportHistoryListQuery, ImportHistoryListQueryVariables>,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ImportHistoryListQuery, ImportHistoryListQueryVariables>(
    ImportHistoryListDocument,
    options,
  );
}
export type ImportHistoryListQueryHookResult = ReturnType<typeof useImportHistoryListQuery>;
export type ImportHistoryListLazyQueryHookResult = ReturnType<typeof useImportHistoryListLazyQuery>;
export type ImportHistoryListSuspenseQueryHookResult = ReturnType<typeof useImportHistoryListSuspenseQuery>;
